var map = {
	"./more_to_explore_desktop.svg": 70272,
	"./more_to_explore_desktop_uk_au.svg": 53684,
	"./more_to_explore_mobile.svg": 48862,
	"./more_to_explore_mobile_uk_au.svg": 99126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82517;